module.exports = __webpack_public_path__ + "a5f130260df4075d3c801f4d243a9aa3.mp4";


//////////////////
// WEBPACK FOOTER
// ./static/videos/MultibandAdaptiveDirectionalityON.mp4
// module id = 395
// module chunks = 0